module.exports = __webpack_public_path__ + "img/x2.70bd26dc.png";